import styled from "styled-components";

import { blue, grayScale } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";

export const Container = styled.div`
  display: flex;
  gap: 9px;

  width: 100%;
  padding-left: 0;
`;

export const ContentWrapper = styled.div`
  position: relative;

  width: 100%;
`;

export const WriterAndTime = styled.div`
  display: flex;
  gap: 4px;
`;

export const Writer = styled(Typo.Text)`
  color: ${grayScale[900]};
  font-weight: 600;
`;

export const Time = styled(Typo.Text)`
  color: ${grayScale[500]};
`;

export const CommentContent = styled(Typo.Text)`
  margin-top: 4px;

  color: ${grayScale[900]};
  white-space: pre-wrap;
  word-break: break-word;

  & > a {
    color: ${blue.main};
    text-decoration: underline;
  }
`;

export const IconWrapper = styled.span<{ $size: number }>`
  display: inline-block;

  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;

  transform: rotateX(180deg) scaleX(-1);
`;

export const ReplyIconWrapper = styled(IconWrapper)`
  transform: rotateX(180deg) scaleX(-1);
`;

export const ReplyButton = styled.button`
  display: flex;
  gap: 4px;
  align-items: center;

  margin-top: 8px;

  span {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const MenuIconWrapper = styled(IconWrapper)<{ $shouldShow: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  display: ${({ $shouldShow }) => ($shouldShow ? "block" : "none")};

  cursor: pointer;
`;
